export const config = {
  baseURL: 'https://crsapitest.trin-it.nl',
  uiURL: 'https://demo.europecamperparking.eu/',
  // baseURL: '',
  // testUsername: 'zoltan.horvath.test@narabi.nl',
  testUsername: '',
  // testPassword: 'almafa',
  testPassword: '',
}



//////////////////
// WEBPACK FOOTER
// ./static/campsite-ui-config.js
// module id = Jh00
// module chunks = 1